module.exports = __webpack_public_path__ + "static/media/18ECA33.0586a015.jpg";